import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { getSectorIcon } from '../../utils/sectorIcons';

const toNepaliNumber = (num) => {
  const nepaliDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
  return String(num).replace(/[0-9]/g, (digit) => nepaliDigits[digit]);
};

const PrioritySectorCard = ({ sector, language = 'ne' }) => {
  const IconComponent = getSectorIcon(sector);
  const count = Array.isArray(sector.subSectors)
    ? sector.subSectors.length
    : typeof sector.subSectorsCount === 'number'
    ? sector.subSectorsCount
    : Array.isArray(sector.subRegions)
    ? sector.subRegions.length
    : typeof sector.subRegions === 'number'
    ? sector.subRegions
    : typeof sector.subSectors === 'number'
    ? sector.subSectors
    : 0;

  const title = language === 'ne' ? (sector.nepaliTitle || sector.name || sector.title) : (sector.title || sector.name || sector.nepaliTitle);
  const description = language === 'ne'
    ? (sector.nepaliDescription || sector.description)
    : (sector.description || sector.nepaliDescription);
  const subSectorLabel = language === 'ne'
    ? `${toNepaliNumber(count)} उप-क्षेत्रहरू`
    : `${count} Sub-sectors`;
    

  return (
    <Link 
      to={`/sector/${sector.slug || sector._id || sector.nepaliSlug}`}
      className="priority-sector-card"
      aria-label={`${title} - ${description}`}
    >
      {/* Card Header with Icon Badge and Arrow */}
      <div className="priority-sector-card__header">
        <div className="priority-sector-card__badge-wrapper">
          <div className="priority-sector-card__icon-badge" aria-hidden="true">
            {IconComponent ? <IconComponent /> : <span style={{ fontSize: 20 }}>{sector.icon || '📋'}</span>}
          </div>
          <span className="priority-sector-card__label">PRIORITY AREA</span>
        </div>
        <div className="priority-sector-card__arrow">
          <ArrowUpRight />
        </div>
      </div>

      {/* Card Content - Titles and Description */}
      <div className="priority-sector-card__content">
        <h3 className="priority-sector-card__title">
          {title}
        </h3>
        <p className="priority-sector-card__description">
          {description}
        </p>
      </div>

      {/* Card Footer - Sub-sectors */}
      <div className="priority-sector-card__footer">
        <div className="priority-sector-card__subregions">
          <span>{subSectorLabel}</span>
        </div>
      </div>
    </Link>
  );
};

export default PrioritySectorCard;
